import BranchSummaryDto from "@/models/Branches/BranchSummaryDto";
import AgencyUserSummaryDto from "@/models/AgencyUsers/AgencyUserSummaryDto";
import WorkerSummaryDto from "@/models/Workers/WorkerSummaryDto";
import ContactSummaryDto from "@/models/Contacts/ContactSummaryDto";
import JobLocationSummaryDto from "@/models/Locations/JobLocationSummaryDto";
import JobRequirementsSummaryDto from "@/models/Jobs/JobRequirementsSummaryDto";
import JobInterviewSummaryDto from "@/models/JobWorkerInterviews/JobWorkerInterviewSummaryDto";
import AgencyIdentifierDto from "@/models/Agencies/AgencyIdentifierDto";


export default class AnonJobWorkerInterviewDto {
    jobWorkerInterviewId = '';
    updatedAt: Date;
    url = '';
    agencyIdentifier: AgencyIdentifierDto = new AgencyIdentifierDto();
    agencyBranch: BranchSummaryDto = new BranchSummaryDto();
    agencyOwner: AgencyUserSummaryDto = new AgencyUserSummaryDto();
    worker: WorkerSummaryDto = new WorkerSummaryDto();
    contact: ContactSummaryDto = new ContactSummaryDto();
    location: JobLocationSummaryDto = new JobLocationSummaryDto();
    requirements: JobRequirementsSummaryDto = new JobRequirementsSummaryDto();
    interview: JobInterviewSummaryDto = new JobInterviewSummaryDto();
    allowDeclineInterview = false;
}
